/**
 * Systems — the units of work a tick is made of.
 *
 * The reducer itself knows nothing about the game. It advances the clock,
 * validates intents, and runs an ordered list of systems at the right tick
 * boundaries. Movement (M0-04), wound clocks (M1-04), weather (M3-05) and
 * infection (M1-05) all arrive as systems on this seam, which is what keeps
 * `advance` a fixed, testable 60 lines while the game grows around it.
 *
 * Ordering is explicit and total: systems run in array order within a phase,
 * phases run in the order below. Nothing is implicit, because "why did that
 * fire first?" is the second-worst question to answer about a simulation and
 * "why is the replay different?" is the worst.
 */
/** Phase execution order within a tick. */
export const TICK_PHASES = ['sim', 'hour', 'day'];
//# sourceMappingURL=system.js.map